
import { popover } from 'element-ui';
import listData from '~/components/public/official-accounts/official-list.js';
export default {
  name: 'OfficialAccounts',
  components: {
    elPopover: popover,
  },
  computed: {
    dataList() {
      const locale = this.$i18n.locale;
      const arr = [];
      listData.slice(0, 9).forEach(item => {
        const obj = {
          icon: item.icon,
          qrcode: item.qrcode,
        };
        Object.assign(obj, item[locale]);
        arr.push(obj);
      });
      return arr;
    },
  },
};
